import { api } from './client';
import type { HealthMetric } from '@/types/Health';

export const healthApi = {
  history: () => api<HealthMetric[]>('/api/health/metrics'),
  upsert: (body: HealthMetric) =>
    api<HealthMetric>('/api/health/metrics', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  remove: (date: string) =>
    api<void>(`/api/health/metrics/${encodeURIComponent(date)}`, {
      method: 'DELETE',
    }),
};
